module.exports = __webpack_public_path__ + "img/tubiao1.fc0efc6d.png";